<template>
  <div class="theme-primary">
    <div class="container-fluid">
      <h1>hello times: {{ helloTimes }}</h1>
      <h2>hello times: {{ helloTimes }}</h2>
      <h3>hello times: {{ helloTimes }}</h3>
      <p>hello times: {{ helloTimes }}</p>
      <button v-on:click="sayHello">Say Hello</button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "../../sass/_config/variables";
div {
  color: $color2;
}
</style>

<script>
export default require("./example-presenter").default;
</script>